<!--
 * @Description: ================== 游戏介绍 =================
 * @Date: 2022-05-13 18:08:07
 * @Author: Zero
 * @FilePath: \guobao-web\src\components\Game.vue
 * @LastEditors: Zero
 * @LastEditTime: 2022-06-14 14:51:49
-->
<template>
  <div class="page page-game">
    <div style="margin-top:20px">
      <img src="/banner.jpg" alt="" style="width: 100%" />
    </div>
    <h2 class="title">游戏介绍</h2>
    <p>欢迎来到《命途之征》，缔结你的契约，与英灵奔赴宿命之战！这片崩坏的时空，正等待你的救赎。</p>
    <!-- <pre> -->
    <div class="content">
      <div class="content-item">
        <h4>【昼夜修行，淬炼冠位英灵】</h4>
          时限？从未束缚王者！离线静修，魔力永续流转，你的英灵每分每秒都在蜕变成长。上线一键尽收养成资源，等级狂飙，战力突破冠位上限！圣杯征途，强者恒强！
        <img src="/1.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【职阶协战，鏖战圣杯秘境】</h4>
          直面汹涌来袭的暗影敌寇，在圣杯秘境深处对决远古强敌与宿命BOSS！依托职阶克制、阵容搭配打出极致合击宝具，斩断轮回虚妄。真正的胜利，属于运筹帷幄的御主！
        <img src="/2.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【登顶星途，铸就宿命传说】</h4>
          从新晋御主到圣域巅峰，你的每一场鏖战、每一次契约，都将镌刻于全域榜单之上。统领顶尖英灵，解锁终极战术，成为令整个宿命世界俯首的传奇主宰！最强契约，由你定义！
        <img src="/3.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【无限召唤，集结历代英灵】</h4>
          宿命未至？只因机缘未临！完成御主试炼，即赠千次召唤机缘。圣剑、神弓、魔枪齐聚现世，传奇从者尽数登场。组建专属冠位战队，书写圣杯战争的全新传奇！
        <img src="/4.jpg" alt="" />
      </div>
    </div>
    <!-- </pre> -->
  </div>
</template>

<style scss>
.content-item {
  display: inline-block;
  width: 50%;
  padding: 12px;
  box-sizing: border-box;
  vertical-align: top;
}
.content-item img {
  display: block;
  margin-top: 12px;
  width: 400px;
}
@media screen and (max-width: 768px) {
  .content-item {
    width: 100%;
  }
  .content-item img {
    width: 100%;
  }
}
</style>
